import { http } from '@/http'

export default {
  getPeriods(companyId) {
    return http.get('/cts', { params: { companyId } })
  },
  getPeriodDetail(id) {
    return http.get(`/cts/${id}`)
  },
  calculate(data) {
    return http.post('/cts/calculate', data)
  },
  confirm(id) {
    return http.put(`/cts/${id}/confirm`)
  },
  excludeDetail(detailId, exclude, reason) {
    return http.put(`/cts/details/${detailId}/exclude`, null, { params: { exclude, reason } })
  },
  adjustDetail(detailId, data) {
    return http.put(`/cts/details/${detailId}/adjust`, data)
  },
  downloadXlsx(id) {
    return http.post(`/cts/${id}/xlsx`, null, { responseType: 'blob' })
  },
}
